module.exports = {
    blog_title:'Taption 資訊專區',
    blog_desc:'提供相關文章，產品細節給創作者。也能在這裡找到Taption相關更新，新聞等資訊。',
    written_by: '作者', 
}